import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/tools/construction-cost-calculator/client/CostCalculatorClient.tsx");
